import React from 'react';
import { useParams } from 'react-router-dom';
import { BoardComposition } from '../components/board/BoardComposition';

export default function BoardCompositionPage() {
    const { id } = useParams();
    return <BoardComposition termId={id} />;
}
